// RecentReportsPanel — quick-access panel of recently generated reports
import type { ReportItem } from "@/mocks/relatorios";
import ReportStatusBadge from "./ReportStatusBadge";

interface Props {
  reports: ReportItem[];
  onView: (r: ReportItem) => void;
}

export default function RecentReportsPanel({ reports, onView }: Props) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-100">
        <h3 className="text-sm font-semibold text-foreground-900">Relatórios Recentes</h3>
        <span className="text-xs text-foreground-400">{reports.length} relatórios</span>
      </div>
      <div className="divide-y divide-background-100">
        {reports.map((r) => (
          <div
            key={r.id}
            onClick={() => onView(r)}
            className="flex items-center gap-3 px-4 py-3 hover:bg-background-50 cursor-pointer transition-colors"
          >
            <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
              <i className="ri-file-text-line text-primary-500 w-full h-full flex items-center justify-center text-sm" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-foreground-900 truncate">{r.title}</div>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="text-xs text-foreground-400">{r.projectName}</span>
                <span className="text-xs text-foreground-300">·</span>
                <span className="text-xs text-foreground-400">{r.generatedAt}</span>
              </div>
            </div>
            <ReportStatusBadge status={r.status} />
            <button
              onClick={(e) => { e.stopPropagation(); onView(r); }}
              className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-primary-600 hover:bg-primary-50 transition-colors shrink-0"
            >
              <i className="ri-eye-line w-4 h-4 flex items-center justify-center text-sm" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}